/**
 * Status of an extraction run
 */
export enum ExtractionRunStatus {
  PENDING = 'pending',
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  FAILED = 'failed'
}

/**
 * Controls when extraction should run for a document type that has a registered schema.
 *
 * - ALWAYS            — always run extraction regardless of existing field values
 * - WHEN_FIELDS_EMPTY — skip if every target field already has a value at upload time
 */
export enum ExtractionProcessingMode {
  ALWAYS = 'always',
  WHEN_FIELDS_EMPTY = 'when-fields-empty'
}

/**
 * Which row an extraction schema populates — the row whose current values decide whether
 * extraction would add anything. Declared per schema, since several schemas share one entity.
 *
 * - TRUST_SELLER_DETAILS   — one selling-party row, located by a document metadata key
 * - TRUST_ACCOUNT_ASSET     — the trust account's one shared asset row, no further narrowing
 * - NONE                    — nothing persisted to compare against, so extraction always runs
 */
export enum ExtractionTargetKind {
  TRUST_SELLER_DETAILS = 'trust_seller_details',
  TRUST_ACCOUNT_ASSET = 'trust_account_asset',
  NONE = 'none'
}

/**
 * Why extraction was skipped for a document.
 * Persisted in logs and verdicts for observability.
 */
export enum ExtractionSkipReason {
  NO_SCHEMA = 'no_schema',
  CONTEXT_MISMATCH = 'context_mismatch',
  ALL_FIELDS_POPULATED = 'all_fields_populated',
  SKIP_PROCESSING_REQUESTED = 'skip_processing_requested'
}
